<template>
  <!-- 案例展示 -->
  <div class="container case">
    <div class="case-header">
      <h2>案例展示</h2>
    </div>
    <el-row :gutter="gutter" class="row-box">
      <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
        <div class="cartoon-img case-img">
          <el-image 
            lazy
            src="https://cdn.renderg.com/download/www/renderg_dist/images/case1.png"
            onerror="../../assets/image/loadimg/case1.jpg"
            alt="">
              <div slot="placeholder" class="image-slot">
                <img src="../../assets/image/loadimg/case1.jpg" alt="">
              </div>
            </el-image>
        </div>
      </el-col>
      <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16">
        <div class="cartoon-img case-img">
          <el-image 
            lazy
            src="https://cdn.renderg.com/download/www/renderg_dist/images/case2.png" 
            onerror="../../assets/image/loadimg/case2.jpg"
            alt="">
            <div slot="placeholder" class="image-slot">
              <img src="../../assets/image/loadimg/case2.jpg" alt="">
            </div>
          </el-image>
        </div>
      </el-col>
      <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
        <div class="cartoon-img case-img">
          <el-image 
            lazy
            src="https://cdn.renderg.com/download/www/renderg_dist/images/case3.png" 
            onerror="../../assets/image/loadimg/case3.jpg"
            alt="">
            <div slot="placeholder" class="image-slot">
              <img src="../../assets/image/loadimg/case3.jpg" alt="">
            </div>
          </el-image>
        </div>
        <div class="cartoon-img case-img">
          <el-image 
            lazy
            src="https://cdn.renderg.com/download/www/renderg_dist/images/case4.png" 
            onerror="../../assets/image/loadimg/case4.jpg"
            alt="">
            <div slot="placeholder" class="image-slot">
              <img src="../../assets/image/loadimg/case4.jpg" alt="">
            </div>
          </el-image>
        </div>
      </el-col>
      <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
        <div class="cartoon-img case-img">
          <el-image 
            src="https://cdn.renderg.com/download/www/renderg_dist/images/case5.png" 
            onerror="../../assets/image/loadimg/case5.jpg"
            alt="">
            <div slot="placeholder" class="image-slot">
              <img src="../../assets/image/loadimg/case5.jpg" alt="">
            </div>
          </el-image>
        </div>
      </el-col>
      <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="last-col">
        <div class="cartoon-img case-img">
          <el-image 
            src="https://cdn.renderg.com/download/www/renderg_dist/images/case6.png" 
            onerror="../../assets/image/loadimg/case6.jpg"
            alt="">
            <div slot="placeholder" class="image-slot">
              <img src="../../assets/image/loadimg/case6.jpg" alt="">
            </div>
          </el-image>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      gutter: 6
    }
  },
  created() {
    if (document.documentElement.clientWidth < 993) {
      this.gutter = 2
    }
  },
}
</script>